import SiteLayout from "@/components/site/SiteLayout";
import FAQAccordion from "@/components/site/FAQAccordion";
import { BRAND } from "@/config/brand";
import useSeo from "@/lib/useSeo";

const FAQ_ITEMS = [
  { q: "How fast do I get paid?", a: "Payouts happen once your card is verified. PayPal and Zelle are usually the fastest — Bitcoin can take a bit longer for confirmation. You'll get an email at every status change." },
  { q: "What's the minimum card value?", a: `We accept cards from $${BRAND.minCardValue}. Anything below is auto-rejected — the review overhead makes smaller cards unprofitable to buy.` },
  { q: "Which brands do you accept?", a: "100+ major retailers including Amazon, Walmart, Target, Apple, Steam, PlayStation, Uber, and more. Full list on our rates page." },
  { q: "Is my card information safe?", a: "Card numbers are hashed for duplicate detection. Only reviewed admin users can see the full number, and every access is audit-logged." },
  { q: "What if my card gets rejected?", a: "You'll see the exact reason on your track page. Most rejections are: face value under $50, brand not accepted, or duplicate detection." },
  { q: "Can I sell multiple cards?", a: "Yes — submit them one at a time. Each gets its own reference and can be tracked independently." },
  { q: "Do you buy partial-balance cards?", a: "Yes. Enter the current balance instead of the original face value. We'll verify before payout." },
  { q: "Can I cancel a submission?", a: "Yes, until it enters 'approved' status. Contact us via the chat widget or support email." },
  { q: "How are payouts calculated?", a: "Each brand has a live buyback rate. Your payout = amount × rate. Zero fees, fully transparent. The number in your calculator is what you get." },
  { q: "Do you buy international cards?", a: "Right now, US-issued cards only. International expansion is on the roadmap." },
];

export default function FAQPage() {
  useSeo({
    title: "Gift Card Buyback FAQ — Payouts, Rates & Rejections | GC Nexon",
    description: "Answers to the most common questions about selling gift cards to GC Nexon: payout speed, accepted brands, minimum values, verification, and rejections.",
    path: "/faq",
  });
  return (
    <SiteLayout>
      <section className="section-py container-x max-w-4xl">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase mb-4">FAQ</span>
        <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight">Gift card buyback questions, answered.</h1>
        <p className="mt-4 text-muted-foreground text-lg">Everything about how selling gift cards to GC Nexon works — payouts, rates, verification, and what to do if something goes wrong. Still stuck? Miles (chat widget bottom-right) or <a href={`mailto:${BRAND.email}`} className="text-primary underline">{BRAND.email}</a>.</p>
        <div className="mt-14">
          <FAQAccordion items={FAQ_ITEMS} />
        </div>
      </section>
    </SiteLayout>
  );
}
